module.exports = __webpack_public_path__ + "img/director.a05038ee.png";